import { useState } from 'react'
import ChannelInfo from 'shared/components/channel-info/info'
import { fetchChannel } from 'shared/api/channels'
import { IChannel } from 'shared/types/channel'
import useAsyncEffect from 'shared/hooks/use-async-effect'

type Props = {
    channelId: number
    isOwner: boolean
}

const ChannelInfoEnhanced = ({ channelId, isOwner }: Props) => {
    const [isFetching, setIsFetching] = useState(true)
    const [channel, setChannel] = useState<IChannel>()

    useAsyncEffect(async () => {
        setChannel(await fetchChannel(channelId))
        setIsFetching(false)
    }, [])
    return !isFetching ? <ChannelInfo channel={channel} isOwner={isOwner} search={''} isTagView={false} /> : null
}

export default ChannelInfoEnhanced
